import React, { useState } from 'react';
import { LayoutAnimation, View } from 'react-native';
import { connect } from 'react-redux';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

import {
  edit as editClampingTools,
  getTools as getClampingTools,
  remove as removeClampingTool,
  create as createClampingTools,
} from '../../../../reducers/clampingTools';
import { getTools, remove, edit } from '@reducers/tools';

import ColorWrapper from '@styles/colors';

import ClampingToolDetails from './clampingToolDetails';
import ToolDetails from './toolDetails';
import ToolList from './toolList';

import AddTool from '@components/tool/components/addTool';
import EditTool from '@components/tool/components/editTool';
import { isPhone } from '@helpers';

const MODES = {
  CLAMPING_TOOL_DETAILS: 'CLAMPING_TOOL_DETAILS',
  TOOL_DETAILS: 'TOOL_DETAILS',
  EDIT_TOOL_DETAILS: 'EDIT_TOOL_DETAILS',
  SELECT_TOOL: 'SELECT_TOOL',
  ADD_TOOL: 'ADD_TOOL',
};

const ClampingToolDetailsWrapper = (props) => {
  const { newTool, tools, hide } = props;

  const [mode, setModeValue] = useState(newTool ? (tools?.tools?.length ? MODES.SELECT_TOOL : MODES.ADD_TOOL) : MODES.CLAMPING_TOOL_DETAILS);
  const t = props?.clampingTool || {};
  const [tool, setTool] = useState(
    newTool
      ? {}
      : {
          toolId: t.toolId,
          toolName: t.toolName,
          description: t.toolDescription,
          memo: t.toolMemo,
          stickoutMM: t.toolStickoutMM,
        }
  );

  const [clampingTool, setClampingTool] = useState(newTool ? {} : props.clampingTool);
  const [editConfig, setEditConfig] = useState({});
  const [selectToolCloseModal, setSelectToolCloseModal] = useState(true);
  const setMode = (v) => {
    LayoutAnimation.easeInEaseOut();
    setModeValue(v);
  };

  const renderComponent = () => {
    const p = {
      ...props,
      tool,
      setMode,
      setTool,
      MODES,
      setEditConfig,
      editConfig,
      clampingTool,
      selectToolCloseModal,
      setSelectToolCloseModal,
    };
    switch (mode) {
      case MODES.CLAMPING_TOOL_DETAILS:
        return <ClampingToolDetails {...p} />;
      case MODES.TOOL_DETAILS:
        return <ToolDetails {...p} />;
      case MODES.EDIT_TOOL_DETAILS:
        return (
          <EditTool
            {...{
              ...p,
              showEdit: true,
              toogleEdit: () => {
                setMode(MODES.TOOL_DETAILS);
              },
              isPopup: false,
              rounded: !isPhone,
              clampingTool,
            }}
          />
        );
      case MODES.SELECT_TOOL:
        return <ToolList {...p} />;
      case MODES.ADD_TOOL:
        return (
          <AddTool
            {...{
              ...p,
              showAddTool: true,
              toogleShowAddTool: ({ success }) => {
                if (tools?.tools?.length || success) {
                  setMode(MODES.SELECT_TOOL);
                } else {
                  hide();
                }
              },
              isPopup: false,
              rounded: !isPhone,
            }}
          />
        );
      default:
        return null;
    }
  };

  return <View testID={TEST_IDS.clampingTool.detailsPopup}>{renderComponent()}</View>;
};

const mapStateToProps = ({ clampingTools, tools }) => ({ clampingTools, tools });

export default connect(mapStateToProps, {
  getTools,
  editClampingTools,
  getClampingTools,
  createClampingTools,
  remove,
  removeClampingTool,
  edit,
})(ColorWrapper(ClampingToolDetailsWrapper));
